import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/phone/usePhoneAuthQueryKeys.ts
var t = e("phone-auth", { capabilities: () => ["capabilities"] });
//#endregion
export { t as phoneAuthQueryKeys };
